import React, { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { get, set, capitalize, indexOf, find, findIndex } from 'lodash';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';

import { trims } from 'utils';
import { RolesMode } from 'entities/Roles';
import { useModal } from 'modules/shared/hooks';
import ScanerBtn from 'modules/common/ScanerBtn';
import { peripheralsSelector } from 'modules/common/Header/selectors';
import ErrorMsg from 'modules/shared/ErrorMsg';
import YesNoModal from 'modules/shared/YesNoModal';
import VerifyPhone from 'modules/common/VerifyPhoneBtn';
import GroupBtnLight from 'modules/shared/Forms/GroupBtnLight';
import { Input, MaskInput, Checkbox, UpploadBtn } from 'modules/shared/Forms';
import { Document } from 'entities/Document';
import { faceIDSelector } from 'modules/security/containers/TripContainer/services/selectors';
import { addFaceIDSelector } from 'modules/ordering/containers/TripContainer/services/selectors';
import { logoutSelector, branchTitleSelector } from 'modules/common/LogoutBtn/selectors';
import { tripStatuses, TripStatusIds, tripDetailsType } from '../../../../../entities/Trip';

import EditFlight from '../EditFlight';
import AcceptModal from '../AcceptModal';
import CommentModal from '../CommentModal';
import TrackInput from '../TrackInput';
import { getAllBranchRequest } from '../../../../common/LogoutBtn/actions';
import Loader from '../../../../kiosk/components/Loader';
import { postBlackListRequest } from '../../../../security/reports/ReportSpecialList/actions';
import { getTripRequest } from '../../../../common/CommonTrip/actions';

type Props = {
  type: tripDetailsType;
  handleChange: any;
  statusId: TripStatusIds;
  mode: RolesMode;
  documents: Document[];
  setFocus: Dispatch<SetStateAction<string>>;
  isVerified?: boolean;
  isOptRequired?: boolean;
  onFaceID?: (type: string) => void;
  operatingProcedure?: string | null;
};

const DriverInfoGrid: React.FC<Props> = React.memo(
  ({
    type,
    mode,
    handleChange,
    statusId,
    isVerified = false,
    documents,
    isOptRequired = false,
    onFaceID,
    setFocus,
    operatingProcedure,
  }) => {
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState('');
    const [toBlackList, setToBlackList] = useState('');

    useEffect(() => {
      dispatch(getAllBranchRequest());
    }, []);

    const formik = useFormikContext();
    const { setFieldValue, setFieldTouched, values } = formik;
    const peripherals = useSelector(peripheralsSelector);
    const { loadFaceID, errorFaceID, fieldFaceID } = useSelector(faceIDSelector);
    const { loadFaceIdAdd, errorFaceIdAdd, fieldFaceIdAdd } = useSelector(addFaceIDSelector);
    const { branches, loading } = useSelector(logoutSelector);
    const branchTitleData = useSelector(branchTitleSelector);
    const useVisitorDoc: boolean = branchTitleData?.useVisitorDoc ?? true;
    const branchTitle = JSON.parse(localStorage.getItem('branchId') || 'null');
    const currentBranch = localStorage.getItem('branchId');
    const currentBranchId = currentBranch ? JSON.parse(currentBranch).id : '';
    const filtered = find(branches, (branch) => branch?.id === currentBranchId);
    const { isShow, closeModal } = useModal();
    const { isShow: isShowBLModal, openModal: openModalBLModal, closeModal: closeModalBLModal } = useModal();
    const { isShow: isShowСomment, openModal: openModalComment, closeModal: closeModalComment } = useModal();

    const isSecurity = mode === 'security';
    const isDirector = mode === 'director';
    const isOrdering = mode === 'ordering';
    const isDriver = type === 'driver';
    const loadingFace = isSecurity ? loadFaceID : loadFaceIdAdd;
    const errorFace = isSecurity ? errorFaceID : errorFaceIdAdd;
    const fieldFace = isSecurity ? fieldFaceID : fieldFaceIdAdd;
    const showForSecurity = [tripStatuses.create, tripStatuses.parkingInLine, tripStatuses.unloading].includes(
      statusId,
    );

    // const driverBlackList = get(values, `driver.isBlackList`, false);
    // const forwarderBlackList = get(values, `forwarder.isBlackList`, false);

    // @ts-ignore
    const isValid = get(formik.values, `is${capitalize(type)}PhoneNumberValid`);
    // @ts-ignore
    const isDisabled =
      (isSecurity && !showForSecurity) || (statusId !== tripStatuses.parkingInLine && isVerified) || isDirector;

    const markAsRequired = ((isSecurity && operatingProcedure === 'Порядок 1') || isOrdering) && type === 'driver';
    // @ts-ignore
    const { id, firstName, lastName, middleName, phone, isFaceId } = values[type];
    const isFullPhone = phone?.number.replace(/\D/g, '').length === 12;
    const isDisabledPhone = !phone || !isFullPhone;
    // @ts-ignore
    const { tripIntention } = values;
    const disableCheckOrd =
      isDirector ||
      (isOrdering && !firstName) ||
      (isOrdering && !lastName) ||
      (isOrdering && !middleName) ||
      (isOrdering &&
        useVisitorDoc &&
        isDriver &&
        !documents[findIndex(documents, (doc: any) => doc.type === 1)]?.number) ||
      (isOrdering &&
        useVisitorDoc &&
        !isDriver &&
        !documents[findIndex(documents, (doc: any) => doc.type === 3)]?.number) ||
      (isOrdering &&
        useVisitorDoc &&
        isDriver &&
        documents[findIndex(documents, (doc: any) => doc.type === 1)]?.pictures?.length === 0 &&
        !documents[findIndex(documents, (doc: any) => doc.type === 1)]?.pictureFiles) ||
      (isOrdering &&
        useVisitorDoc &&
        !isDriver &&
        !documents[findIndex(documents, (doc: any) => doc.type === 3)]?.pictureFiles &&
        !documents[findIndex(documents, (doc: any) => doc.type === 3)]?.pictures);

    const doumentType1 = documents?.find((doc: any) => doc.type === 1) || {
      number: '',
      type: 1,
      pictures: [],
    };
    const doumentType3 = documents?.find((doc: any) => doc.type === 3) || {
      number: '',
      type: 3,
      pictures: [],
    };
    const indexDoc1 = indexOf(documents, doumentType1);
    const indexDoc3 = indexOf(documents, doumentType3);

    const filesHandler = (index: number) => (event: ChangeEvent<HTMLInputElement>) => {
      const fieldName = `${type}.documents[${index}].pictureFiles`;
      const images = get(documents, `[${index}].pictureFiles`, []);
      // @ts-ignore
      setFieldValue(fieldName, [...images, ...event.currentTarget.files]);
    };

    const onToBlackList = () => {
      setToBlackList(id);
      openModalBLModal();
    };

    const onAddBL = (data: any) => {
      dispatch(postBlackListRequest(data));
      // @ts-ignore
      setTimeout(() => dispatch(getTripRequest(values.id)), 500);
    };

    const onChangeDocuments = (e: any) => {
      set(e.target, 'value', trims(e.target.value));

      return handleChange(e);
    };

    useEffect(() => {
      if (+tripIntention === 2 && statusId === tripStatuses.create) {
        // @ts-ignore
        if (!documents?.length || !documents[0]?.pictures?.length || documents[0]?.pictureFiles?.length < 1) {
          formik.setFieldError(type, "Поле обов'язкове");
        }
      }
    }, [tripIntention]);

    useEffect(() => {
      if (isFaceId) {
        setFieldTouched(type);
      }
    }, [isFaceId]);

    return (
      <>
        {loading && <Loader />}
        <Col xs={12} sm={12} lg={8}>
          <MaskInput
            name={`${type}.phone.number`}
            label="Телефон"
            placeholder="38 (0XX) XXX-XX-XX"
            onChange={(e: React.ChangeEvent<any>) => {
              if (type === 'driver') {
                setFieldValue('driver.isBlackList', false);
                handleChange(e);
              }
              if (type === 'forwarder') {
                setFieldValue('forwarder.isBlackList', false);
                handleChange(e);
              }
            }}
            requestParamName="phoneNumber"
            isDisabledBtnDots={isDisabled}
            disabled={isDisabled}
            isRequired={markAsRequired}
            isOptRequired={isOptRequired}
            onFocus={() => setFocus('')}
            value={phone?.number}
          >
            {filtered &&
            filtered.sendPhoneVerification &&
            isSecurity &&
            operatingProcedure === 'Порядок 1' &&
            statusId === 1 ? (
              <div className="d-flex flex-row align-items-center">
                <VerifyPhone
                  mode="main"
                  value={phone?.number.replace(/\D/g, '')}
                  inputVerifyField={`is${capitalize(type)}PhoneNumberValid`}
                  disabled={isDisabled || isDisabledPhone}
                />
                {isValid ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    // @ts-ignore
                    overlay={<Tooltip id="button-tooltip-2">Валідацію виконано</Tooltip>}
                  >
                    <CheckIcon size={18} className="ml-2 text-success" />
                  </OverlayTrigger>
                ) : null}
                {isFullPhone && !isValid ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    // @ts-ignore
                    overlay={<Tooltip id="button-tooltip-2">Телефон не валідовано!</Tooltip>}
                  >
                    <CloseIcon size={18} className="ml-2 text-danger" />
                  </OverlayTrigger>
                ) : null}
              </div>
            ) : null}
            {filtered &&
            filtered.sendPhoneVerification &&
            isOrdering &&
            (operatingProcedure === 'Порядок 2' || operatingProcedure === 'Порядок 3') &&
            statusId === 1 ? (
              <div className="d-flex flex-row align-items-center">
                <VerifyPhone
                  mode="main"
                  value={phone?.number.replace(/\D/g, '')}
                  inputVerifyField={`is${capitalize(type)}PhoneNumberValid`}
                  disabled={isDisabled || isDisabledPhone}
                />
                {isValid ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    // @ts-ignore
                    overlay={<Tooltip id="button-tooltip-2">Валідацію виконано</Tooltip>}
                  >
                    <CheckIcon size={18} className="ml-2 text-success" />
                  </OverlayTrigger>
                ) : null}
                {isFullPhone && !isValid ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    // @ts-ignore
                    overlay={<Tooltip id="button-tooltip-2">Телефон не валідовано!</Tooltip>}
                  >
                    <CloseIcon size={18} className="ml-2 text-danger" />
                  </OverlayTrigger>
                ) : null}
              </div>
            ) : null}
          </MaskInput>
          <Input
            name={`${type}.lastName`}
            label="Прізвище"
            onChange={handleChange}
            maxLength={40}
            disabled={isDisabled}
            isRequired={markAsRequired}
            isOptRequired={isOptRequired}
            // @ts-ignore
            onFocus={() => setFocus('')}
          >
            <div className="d-flex flex-row">
              {(isSecurity || (branchTitle && branchTitle?.useFaceScan)) && !isFaceId ? (
                <GroupBtnLight
                  loading={loadingFace}
                  // eslint-disable-next-line
                  errorMsg={errorFace?.message ? errorFace.message : ''}
                  isField={type}
                  isLoadingField={fieldFace}
                  className="mr-1"
                  onClick={onFaceID}
                  disabled={!peripherals?.length || isDisabled}
                  btnIcon="face"
                />
              ) : null}
              {type === 'driver' ? (
                <EditFlight
                  className={branchTitle && branchTitle?.useFaceScan && !isFaceId ? '' : 'ml-1'}
                  clickHandler={onToBlackList}
                  icon="flag"
                  disabled={
                    !id ||
                    !lastName ||
                    isDisabled || // @ts-ignore
                    (type === 'driver' && values.driver.isBlackList) // @ts-ignore
                  }
                />
              ) : (
                <EditFlight
                  className={branchTitle && branchTitle?.useFaceScan && !isFaceId ? '' : 'ml-1'}
                  clickHandler={onToBlackList}
                  icon="flag"
                  disabled={
                    !id ||
                    !lastName ||
                    isDisabled || // @ts-ignore
                    (type === 'forwarder' && values.forwarder.isBlackList)
                  }
                />
              )}
            </div>
          </Input>
          <Input
            name={`${type}.firstName`}
            label="Ім'я"
            onChange={handleChange}
            maxLength={40}
            disabled={isDisabled}
            isRequired={markAsRequired}
            isOptRequired={isOptRequired}
            // @ts-ignore
            onFocus={() => setFocus('')}
          />
          <Input
            name={`${type}.middleName`}
            label="По батькові"
            onChange={handleChange}
            maxLength={40}
            disabled={isDisabled}
            isDisabledBtnDots={isDisabled}
            isRequired={markAsRequired}
            isOptRequired={isOptRequired}
            // @ts-ignore
            onFocus={() => setFocus('')}
          />

          {isDriver && (
            <TrackInput
              name={`${type}.documents[${indexDoc1}].number`}
              label="Номер посвідчення"
              onChange={onChangeDocuments}
              maxLength={40}
              requestParamName="documentNumber"
              isDisabledBtnDots={isDisabled}
              disabled={isDisabled}
              isRequired={markAsRequired && useVisitorDoc}
              isOptRequired={isOptRequired}
              // @ts-ignore
              onFocus={setFocus}
            >
              <div className="d-flex flex-row">
                <ScanerBtn
                  typeDoc={type}
                  index={indexDoc1}
                  isDisabled={isDisabled || !documents[indexDoc1]?.number || documents[indexDoc1]?.number.length < 2}
                />
                <UpploadBtn
                  name={`${type}.documents[${indexDoc1}].pictureFiles`}
                  onChange={filesHandler(indexDoc1)}
                  isDisabled={isDisabled || !documents[indexDoc1]?.number || documents[indexDoc1]?.number.length < 2}
                />
              </div>
            </TrackInput>
          )}

          <TrackInput
            name={`${type}.documents[${indexDoc3}].number`}
            label="Номер паспорту"
            onChange={onChangeDocuments}
            maxLength={40}
            requestParamName="documentNumber"
            isDisabledBtnDots={isDisabled}
            disabled={isDisabled}
            isOptRequired={isOptRequired}
            // @ts-ignore
            onFocus={setFocus}
          >
            <div className="d-flex flex-row">
              <ScanerBtn
                typeDoc={type}
                index={indexDoc3}
                isDisabled={isDisabled || !documents[indexDoc3]?.number || documents[indexDoc3]?.number.length < 2}
              />
              <UpploadBtn
                name={`${type}.documents[${indexDoc3}].pictureFiles`}
                onChange={filesHandler(indexDoc3)}
                isDisabled={isDisabled || !documents[indexDoc3]?.number || documents[indexDoc3]?.number.length < 2}
              />
            </div>
          </TrackInput>

          {((+statusId > 1 && !isSecurity) ||
            (isSecurity && +statusId > 2) ||
            operatingProcedure === 'Порядок 2' ||
            operatingProcedure === 'Порядок 3') && (
            <div className="mt-5">
              <Checkbox
                name={`is${capitalize(type)}DocumentValid`}
                label="Документи верифіковано випискою"
                onChange={handleChange}
                disabled={isSecurity || disableCheckOrd}
                className="col-4 _req-checkbox"
                isRequired={mode === 'ordering' && (isOptRequired || type === 'driver')}
              />
            </div>
          )}
        </Col>
        {isShow && <AcceptModal closeModal={closeModal} value={phone?.number.replace(/\D/g, '')} />}
        <YesNoModal
          isShow={isShowBLModal}
          title="Додати до чорного списку"
          acceptHandler={() => {
            openModalComment();
            closeModalBLModal();
          }}
          closeModal={closeModalBLModal}
        />
        <CommentModal
          isShow={isShowСomment}
          acceptHandler={onAddBL}
          id={toBlackList}
          type={type}
          closeModal={closeModalComment}
        />
        <ErrorMsg isShow={!!errorMsg} error={errorMsg || ''} closeHandler={() => setErrorMsg('')} />
      </>
    );
  },
);

export default DriverInfoGrid;
